(function($) {

	'use strict';

	var init = function() {

        manageLandingPage();

    };
    
    var manageLandingPage = function() {
        $('.lpHeader__phone--desktop').on('click', function() {
            $(this).text($(this).data('phone'));
        });
    }

    var populateLandingPagePosts = function() {

        var $select = $('.gfield_select');

        if($('.gform_validation_errors').length) {

            jQuery.post(
                MyAjax.ajaxurl,
                {
                    'action': 'post_populate_landing_page_posts',
                    'campus_id': $('.lpHero__form').data('campus-id'),
                },
                function(response){

                    var json = jQuery.parseJSON(response);

                    if(json.success) {

                        json.data.forEach(function(element) {

                            $select.append(`<option value="${element.text}">${element.text}</option>`);
    
                        });
                    }
                }
            );
        }
    }

	$(window).on('load', function() {
        if($('.page-template-template-landing-page').length) {
		    init();
        }
	});
    $(document).on('gform_post_render', function() {
        if($('.page-template-template-landing-page').length) {
		    populateLandingPagePosts();
        }
    });

})(jQuery);